import "./App.css";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./components/home";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./components/header";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />  {/* Common Navbar */}
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
